import * as React from "react";

import BillingTab from "./BillingTab";
import OrganizationTab from "./OrganizationTab";
import ProfileTab from "./ProfileTab";
import RolesTabPage from "./RolesTab/RolesTabPage";
import TeamTab from "./TeamTab";

function ProfileContent({ selectedTab }) {
  const renderSelectedTab = React.useCallback(() => {
    switch (selectedTab) {
      case "profile":
        return <ProfileTab />;
      case "organization":
        return <OrganizationTab />;
      case "team":
        return <TeamTab />;
      case "billing":
        return <BillingTab />;
      case "roles":
        return <RolesTabPage />;
      default:
        return "Tab not implemented";
    }
  }, [selectedTab]);

  return (
    <div className="border rounded-tr rounded-br rounded-bl">
      {renderSelectedTab()}
    </div>
  );
}

export default ProfileContent;
